<template>
  <div
    v-if="fields && fields.center && fields.padding"
    class="content-item__wrapper"
    :class="[{ center: fields.center.value === true }, { padding: fields.padding.value === true }]"
  >
    <div>
      <sc-image
        v-if="fields && fields.image"
        :media="fields.image"
        class="content-item__image"
        :class="{ padding: fields.padding.value === true }"
      />
    </div>
    <sc-text
      tag="div"
      class="content-item__label"
      v-if="fields && fields.label"
      :field="fields.label"
    />
    <sc-text
      tag="div"
      class="content-item__heading"
      v-if="fields && fields.headline"
      :field="fields.headline"
    />
    <sc-link
      v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
      :field="fields.cta"
      class="content-item__cta"
      :class="fields.cta.value.class"
    />
  </div>
</template>

<script>
import { Image, Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Carousel-Item',
  components: {
    ScImage: Image,
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.content-item {
  &__wrapper {
    &.center {
      text-align: center;
      align-content: center;
    }

    &.padding {
      width: calc(100% - 3rem);
      margin: 0 1.5rem;

      @include tablet-up {
        width: calc(100% - 6rem);
        margin: 0 3rem;
      }
    }
  }

  &__image {
    width: auto;
    margin: 0 0 2rem 0;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  &__label {
    display: block;
    @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.6rem, 0, $dark-blue);
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }

  &__heading {
    display: block;
    @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);
    text-transform: none;
    margin-bottom: 1.5rem;
  }

  &__cta {
    @include font-styles('Arial Narrow', 1.8rem, 500, normal, 2.2rem, 0, $blue);
    text-transform: uppercase;
  }
}
</style>
